import React from "react";
import { ReactComponent as Auto } from "../../../assets/images/icons/zeppelin-auto-icon.svg";
import { ReactComponent as Calendar } from "../../../assets/images/icons/zeppelin-calendar-icon.svg";
import { ReactComponent as Capitalizacao } from "../../../assets/images/icons/zeppelin-capitalizacao-icon.svg";
import { ReactComponent as Call } from "../../../assets/images/icons/zeppelin-call-icon.svg";
import { ReactComponent as Chat } from "../../../assets/images/icons/zeppelin-chat-icon.svg";
import { ReactComponent as CheckCicle } from "../../../assets/images/icons/zeppelin-check-cicle-icon.svg";
import { ReactComponent as CodeBar } from "../../../assets/images/icons/zeppelin-codebar-icon.svg";
import { ReactComponent as Consorcio } from "../../../assets/images/icons/zeppelin-consorcio-icon.svg";
import { ReactComponent as Emprestimo } from "../../../assets/images/icons/zeppelin-emprestimo-icon.svg";
import { ReactComponent as Habitacional } from "../../../assets/images/icons/zeppelin-habitacional-icon.svg";
import { ReactComponent as Odontologico } from "../../../assets/images/icons/zeppelin-odontologico-icon.svg";
import { ReactComponent as Previdencia } from "../../../assets/images/icons/zeppelin-previdencia-icon.svg";
import { ReactComponent as Residencial } from "../../../assets/images/icons/zeppelin-residencial-icon.svg";
import { ReactComponent as Saude } from "../../../assets/images/icons/zeppelin-saude-icon.svg";
import { ReactComponent as ChevronLeft } from "../../../assets/images/icons/zeppelin-set-left-icon.svg";
import { ReactComponent as Vida } from "../../../assets/images/icons/zeppelin-vida-icon.svg";
import { ReactComponent as Empresarial } from "../../../assets/images/icons/zeppelin-empresarial-icon.svg";
import ZIconStyle from "./ZIcons.Style";

const ZIcon = (props) => <ZIconStyle {...props} />;

export const ZlAutoIcon = (props) => <ZIcon {...props} as={Auto} />;

export const ZlCalendarIcon = (props) => <ZIcon {...props} as={Calendar} />;

export const ZlCapitalizacaoIcon = (props) => {
  return <ZIcon {...props} as={Capitalizacao} />;
};

export const ZlCallIcon = (props) => <ZIcon {...props} as={Call} />;

export const ZlChatIcon = (props) => <ZIcon {...props} as={Chat} />;

export const ZlCheckCicleIcon = (props) => <ZIcon {...props} as={CheckCicle} />;

export const ZlCodeBarIcon = (props) => <ZIcon {...props} as={CodeBar} />;

export const ZlConsorcioIcon = (props) => <ZIcon {...props} as={Consorcio} />;

export const ZlEmprestimoIcon = (props) => <ZIcon {...props} as={Emprestimo} />;

export const ZlEmpresarialIcon = (props) => <ZIcon {...props} as={Empresarial} />;

export const ZlHabitacionalIcon = (props) => (
  <ZIcon {...props} as={Habitacional} />
);

export const ZlOdontologicoIcon = (props) => (
  <ZIcon {...props} as={Odontologico} />
);

export const ZlPrevidenciaIcon = (props) => (
  <ZIcon {...props} as={Previdencia} />
);

export const ZlResidencialIcon = (props) => (
  <ZIcon {...props} as={Residencial} />
);

export const ZlSaudeIcon = (props) => <ZIcon {...props} as={Saude} />;

export const ZlChevronLeftIcon = (props) => (
  <ZIcon {...props} as={ChevronLeft} />
);

export const ZlVidaIcon = (props) => <ZIcon {...props} as={Vida} />;
